export default {
	methods: {
		toast(message) {
			this.$store.dispatch('toast/push', { message })
		},
		toastError(message) {
			this.$store.dispatch('toast/push', {
				message,
				severity: 'error',
			})
		},
	},
}
